import { getListingStatus } from './listingStatus';

/** Buckets a listing into one of the My Listings status tabs. */
export const getStatusBucket = (listing, t) => {
  if (listing.status === 'pending') return 'pending';
  return getListingStatus(listing, t).status; // active | expiring | expired | deleted | sold | hidden
};

export const STATUS_TABS = ['all', 'active', 'pending', 'expiring', 'expired', 'deleted'];

export const sortListings = (list, sortBy) => {
  const arr = [...list];
  switch (sortBy) {
    case 'oldest':
      return arr.sort((a, b) => new Date(a.created_at) - new Date(b.created_at));
    case 'price_asc':
      return arr.sort((a, b) => a.price_mga - b.price_mga);
    case 'price_desc':
      return arr.sort((a, b) => b.price_mga - a.price_mga);
    case 'expiring':
      return arr.sort((a, b) => {
        if (!a.expires_at) return 1;
        if (!b.expires_at) return -1;
        return new Date(a.expires_at) - new Date(b.expires_at);
      });
    case 'most_viewed':
      return arr.sort((a, b) => (b.view_count || 0) - (a.view_count || 0));
    case 'newest':
    default:
      return arr.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
  }
};
